import { Box } from "@mui/material";
import CustomSpinner from "./UI/CustomLoader";

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
      }}
    >
      <CustomSpinner />
    </Box>
  );
};

export default LoadingScreen;
